export const CONDITIONS = [
  "Type 1 Diabetes",
  "Type 2 Diabetes",
  "Crohn's/IBD",
  "Asthma",
  "Epilepsy",
  "Sickle Cell",
  "Heart condition",
  "Anxiety",
  "Autism/Neurodivergent",
];

export const MOBILITY_OPTIONS = [
  { value: "none", label: "No mobility aid" },
  { value: "cane", label: "Cane" },
  { value: "walker", label: "Walker" },
  { value: "manual_wheelchair", label: "Manual wheelchair" },
  { value: "power_wheelchair", label: "Power wheelchair" },
  { value: "scooter", label: "Mobility scooter" },
];

export const SENSORY_OPTIONS = [
  { value: "noise_sensitivity", label: "Noise sensitivity" },
  { value: "light_sensitivity", label: "Light sensitivity" },
  { value: "crowd_avoidance", label: "Crowd avoidance" },
];

export const ACTIVITIES = [
  "sightseeing", "beach", "hiking", "business", "food", "nightlife", "relaxation",
];

export const ACCOMMODATION_TYPES = [
  "Hotel", "Hostel", "Apartment / Airbnb", "Family / friends", "Resort", "Other",
];

export const STAY_BADGE_LABELS = {
  step_free_entrance: "Step-free entrance",
  roll_in_shower: "Roll-in shower",
  hearing_loop: "Hearing loop",
  accessible_parking: "Accessible parking",
};

const CONDITION_ABBR = {
  "Type 1 Diabetes": "T1D",
  "Type 2 Diabetes": "T2D",
  "Crohn's/IBD": "IBD",
  "Asthma": "Asthma",
  "Epilepsy": "Epilepsy",
  "Sickle Cell": "Sickle Cell",
  "Heart condition": "Heart",
  "Anxiety": "Anxiety",
  "Autism/Neurodivergent": "Neurodivergent",
};

export function profileChip(profile) {
  if (!profile) return "";
  const parts = [];
  (profile.conditions || []).slice(0, 2).forEach((c) => parts.push(CONDITION_ABBR[c] || c));
  const mob = MOBILITY_OPTIONS.find((m) => m.value === profile.mobility_needs);
  if (mob && mob.value !== "none") parts.push(mob.value.includes("wheelchair") ? "Wheelchair user" : mob.label);
  return parts.join(" · ");
}

export const RECORD_CATEGORIES = [
  "Lab result", "Imaging", "Prescription", "Discharge summary", "Referral", "Other",
];

export const DISCLAIMER_SHORT =
  "PocketDocta provides travel preparedness guidance, not medical advice.";

export const DISCLAIMER_FULL =
  "PocketDocta is a travel preparedness and wellness platform. It is not a medical device, not telemedicine, and not a diagnostic tool. It never diagnoses, never recommends medication dosages, and never replaces clinicians or emergency services. Always consult your clinician before travel. In an emergency, always call local emergency services.";
